import React from 'react';
import SEO from '../components/shared/SEO';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="Mentions Légales"
        description="Mentions légales du site Foulées Vertes - Informations juridiques et légales"
        noindex={true}
      />
      
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-neuropolitical font-bold text-gray-900 mb-8">Mentions Légales</h1>
        
        <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8">
          {/* Éditeur du site */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Éditeur du site</h2>
            <p className="text-gray-600 leading-relaxed">
              Le site <strong>www.fouleesvertes.fr</strong> est édité par :
            </p>
            <ul className="mt-4 space-y-2 text-gray-600">
              <li><strong>Raison sociale :</strong> Foulées Vertes</li>
              <li><strong>Forme juridique :</strong> [À compléter - SARL, SAS, etc.]</li>
              <li><strong>Capital social :</strong> [À compléter] €</li>
              <li><strong>Siège social :</strong> [Adresse complète à compléter], 63000 Clermont-Ferrand</li>
              <li><strong>SIRET :</strong> [À compléter]</li>
              <li><strong>RCS :</strong> Clermont-Ferrand [À compléter]</li>
              <li><strong>Numéro de TVA intracommunautaire :</strong> [À compléter]</li>
              <li><strong>Téléphone :</strong> 04 73 91 72 20</li>
              <li><strong>Email :</strong> contact@fouleesvertes.fr</li>
              <li><strong>Directeur de la publication :</strong> Karim [Nom à compléter]</li>
            </ul>
          </section>

          {/* Hébergement */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Hébergement</h2>
            <p className="text-gray-600 leading-relaxed">
              Ce site est hébergé par :
            </p>
            <ul className="mt-4 space-y-2 text-gray-600">
              <li><strong>Hébergeur :</strong> [À compléter]</li>
              <li><strong>Adresse :</strong> [À compléter]</li>
              <li><strong>Téléphone :</strong> [À compléter]</li>
            </ul>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Propriété intellectuelle</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              L'ensemble du contenu de ce site (textes, images, vidéos, logos, graphismes, icônes, etc.) est la propriété exclusive de Foulées Vertes ou de ses partenaires, et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Foulées Vertes.
            </p>
          </section>

          {/* Responsabilité */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Limitation de responsabilité</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Foulées Vertes s'efforce d'assurer au mieux l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, Foulées Vertes ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
            </p>
            <p className="text-gray-600 leading-relaxed">
              En conséquence, Foulées Vertes décline toute responsabilité pour les éventuelles imprécisions, inexactitudes ou omissions portant sur des informations disponibles sur ce site.
            </p>
          </section>

          {/* Liens hypertextes */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Liens hypertextes</h2>
            <p className="text-gray-600 leading-relaxed">
              Le site peut contenir des liens hypertextes vers d'autres sites. Foulées Vertes n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou aux éventuels collectes de données personnelles effectuées par ces sites tiers.
            </p>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Cookies</h2>
            <p className="text-gray-600 leading-relaxed">
              Ce site utilise des cookies pour améliorer l'expérience utilisateur et réaliser des statistiques de visites. Pour en savoir plus sur notre utilisation des cookies et sur vos droits, veuillez consulter notre <a href="/confidentialite" className="text-emerald-700 hover:underline">Politique de confidentialité</a>.
            </p>
          </section>

          {/* Droit applicable */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Droit applicable</h2>
            <p className="text-gray-600 leading-relaxed">
              Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
            </p>
          </section>

          {/* Mise à jour */}
          <section className="pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Dernière mise à jour : Janvier 2025
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;